<template>
    <div>
        <b-modal id="modal-smart-drop-plus-preview" centered size="lg" no-close-on-backdrop
            :body-class="'px-3 pt-2 overflow-preview-auto'" no-close-on-esc :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
            :header-class="'align-items-center'" scrollable>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('smartDropPreview.title') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
                <b-dropdown id="dropdown-preview" class="load-dropdown mt-0">
                    <template slot="button-content">
                        <b-icon class="dots" icon="three-dots"></b-icon>
                    </template>
                    <b-dropdown-item-button class="mb-2" @click="downloadFile(mediaID)">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('smartDropPreview.download') }}</p>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button>
                        <p class="text_secondary cursor-pointer mb-0 f-14" v-if="documentItem"
                            @click="showDeletePopup(documentItem.pk)">{{ $t('smartDropPreview.delete') }}</p>
                    </b-dropdown-item-button>
                </b-dropdown>
            </template>
            <div class="d-block text-center">
                <p class="mb-0 text-right f-12" v-if="documentItem">{{ documentItem.documentName }}</p>
                <b-row>
                    <b-col lg="4" sm="12" class="text-left mb-2">
                        <b-row>
                            <b-col sm="12" class="text-left mb-2">
                                <label class="state">{{ $t('smartDropPreview.nameLabel') }}</label>
                                <v-select class="bg_white w-100 f-12" v-model="documentData.name" :options="nameOptions"
                                    item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchAssets"
                                    @option:selected="getNameItem($event)">
                                    <span slot="no-options">
                                        {{ $t('smartDropPreview.searchUnitOrName') }}
                                    </span>
                                </v-select>
                                <p v-if="errors && errors.name" class="field-error">
                                    {{ errors.name[0] }}
                                </p>
                            </b-col>
                            <b-col sm="12">
                                <div class="text-left mb-2">
                                    <label for="modal-smart-drop-plus-datepicker" class="state">{{ $t('smartDropPreview.dateLabel') }}</label>
                                    <date-picker v-model="documentData.date" :formatter="momentFormat"
                                        :range-separator="' - '" @clear="documentData.date = ''" :placeholder="$t('smartDropPreview.selectDate')"
                                        class="date-picker-custom" :teleport="'body'"></date-picker>
                                </div>
                            </b-col>
                            <b-col sm="12">
                                <div class="text-left mb-2">
                                    <label for="modal-smart-drop-plus-expiry-date" class="state">{{ $t('smartDropPreview.expiryDateLabel') }}</label>
                                    <date-picker v-model="documentData.expiry_date" :formatter="momentFormat"
                                        :range-separator="' - '" @clear="documentData.expiry_date = ''"
                                        :placeholder="$t('smartDropPreview.selectDate')" class="date-picker-custom"
                                        :teleport="'body'"></date-picker>
                                </div>
                            </b-col>
                            <b-col sm="12">
                                <div class="text-left mb-2">
                                    <label class="state">{{ $t('smartDropPreview.docTypeLabel') }}</label>
                                    <b-form-select class="f-12" :options="getDotOptions" v-model="documentData.doc_type"
                                        @change="setDocDescription($event)">
                                    </b-form-select>
                                    <p v-if="errors && errors.doc_type" class="field-error">
                                        {{ errors.doc_type[0] }}
                                    </p>
                                </div>
                            </b-col>
                            <b-col sm="12">
                                <div class="text-left mb-2">
                                    <label for="modal-smart-drop-plus-expiry-date" class="state">{{ $t('smartDropPreview.descriptionLabel') }}</label>
                                    <b-form-input type="text" :placeholder="$t('smartDropPreview.descriptionPlaceholder')" v-model="documentData.description"
                                        class="unit f-12"></b-form-input>
                                </div>
                            </b-col>
                            <b-col sm="12" v-if="documentItem && documentItem.source === 'Driver' && documentItem.rejected">
                                <div class="text-left mb-2">
                                    <label for="modal-smart-drop-plus-expiry-date" class="state">{{ $t('smartDropPreview.rejectedReasonLabel') }}</label>
                                    <b-form-input type="text" :placeholder="$t('smartDropPreview.rejectedReasonPlaceholder')"
                                        v-model="documentItem.rejection_reason" class="unit f-12" disabled></b-form-input>
                                </div>
                            </b-col>
                            <b-col sm="12">
                                <div class="text-left mb-2">
                                    <label class="state">{{ $t('smartDropPreview.driverLabel') }}</label>
                                    <b-form-checkbox v-model="documentData.driver" name="check-button" switch size="lg"
                                        class="ml-0-6rem" />
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="8" sm="12" class="text-left mb-2 position-relative">
                        <div class="review-media-section" :class="mediaType === 'pdf' ? 'overflow-hidden' : ''">
                            <iframe class="w-100 h-100 border-0" v-if="mediaType === 'pdf'" :src="media"></iframe>
                            <div v-else>
                                <div id="panzoom-element" ref="panzoomElement">
                                    <img :src="media" class="w-100 h-100 img-section" />
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-center zoom-section"
                                v-if="mediaType !== 'pdf'">
                                <b-icon @click="zoom(1)" icon="zoom-in" style="fill:white; cursor: pointer;"></b-icon>
                                <b-icon @click="zoom(-1)" class="ml-3" icon="zoom-out"
                                    style="fill:white;cursor: pointer;"></b-icon>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <template #modal-footer>
                <div class="d-flex modal-footer border-0 p-0 mt-3"
                    :class="documentItem && (documentItem.source === 'Driver' && !documentItem.rejected) ? 'justify-content-between' : 'justify-content-end'">
                    <div class="d-flex m-0"
                        v-if="documentItem && (documentItem.source === 'Driver' && !documentItem.rejected)">
                        <b-button class="cancel text-white mr-3" @click="$bvModal.show('modal-reject-doc')"
                            variant="danger">{{ $t('smartDropPreview.reject') }}</b-button>
                    </div>
                    <div class="d-flex m-0">
                        <b-button class="btn cancel mr-3" block @click="resetPopup">{{ $t('smartDropPreview.close') }}</b-button>
                        <b-button class="btn save mx-0" variant="primary" @click="updateDocument">{{ $t('smartDropPreview.approve') }}</b-button>
                    </div>
                </div>
            </template>
        </b-modal>
        <RejectDoc :documentItem="documentItem" :documentData="documentData"
            @docRejected="resetPopup(); $emit('docsUpdated')" />
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import * as moment from "moment-timezone";
import RejectDoc from './RejectDoc.vue';
import Panzoom from '@panzoom/panzoom'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
    components: { vSelect, RejectDoc, DatePicker },
    props: ['documentItem', 'company', 'showDeletePopup'],
    computed: {
        ...mapGetters(["docTypeItems", "rolePermissions"]),
        getDotOptions() {
            return [...[{
                value: "",
                text: "",
            }], ...this.docTypeItems?.filter((item) => item.model === this.modelType || item.model === 'All').map((item) => {
                return {
                    value: item.id,
                    text: item.type,
                }
            })]
        },
        allowUpdateDocDrivers() {
            return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][8].allow
        },
        allowUpdateDocEquipment() {
            return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][7].allow
        },
        allowCreateDocEquipment() {
            return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][8].allow
        },
        allowCreateDocDrivers() {
            return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][9].allow
        },
        allowCreateOwnerOperatorDocs() {
            return this.$store.state.user.user.team_member.role === 'Owner Operator'
        },
    },
    data() {
        return {
            nameOptions: [],
            modelType: null,
            panzoom: null,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            documentData: {
                name: "",
                date: "",
                expiry_date: "",
                description: "",
                driver: false,
                doc_type: "",
            },
            media: "",
            mediaID: "",
            mediaType: "",
            errors: {}
        }
    },
    name: "SmartDropPreview",
    watch: {
        async documentItem() {
            if (this.documentItem) {
                this.documentData.description = this.documentItem.description
                this.documentData.date = this.documentItem.date ? moment.tz(this.documentItem.date, this.userTimeZone).toDate() : ''
                this.documentData.expiry_date = this.documentItem.expiry ? moment.tz(this.documentItem.expiry, this.userTimeZone).toDate() : ''
                this.documentData.driver = this.documentItem.driver
                this.documentData.doc_type = this.documentItem.doc_type
                this.modelType = this.documentItem.type
                if (this.documentItem.name !== '-') {
                    this.documentData.name = this.documentItem.userID
                    this.nameOptions = [{
                        id: this.documentItem.userID,
                        label: this.documentItem.name,
                        type: `${this.documentItem.type === "Company" ? 'company' : this.documentItem.type === "Vehicle" || this.documentItem.type === "Trailer" ? 'equipment' : 'teammember'}`,
                        name: `${this.documentItem.type === "Company" ? '' : this.documentItem.name}_`,
                        model: this.documentItem.type
                    }]
                }
                const doc = await this.retrieveDocument(this.documentItem.pk);
                this.media = doc.document
                this.mediaID = this.documentItem.pk
                if (this.documentItem.link.includes('.pdf')) this.mediaType = 'pdf'
                else this.mediaType = 'image'
            }
        }
    },
    methods: {
        ...mapActions(["getFilteredEquipments", "setLoader", "setNotification", "updateTeamMemberDocument", "retrieveDocument", "getFilteredDrivers"]),
        zoom(level) {
            if (!this.panzoom) {
                this.panzoom = Panzoom(document.getElementById('panzoom-element'), {
                    maxScale: 5
                })
            }
            level === -1 ? this.panzoom.zoomOut() : this.panzoom.zoomIn()
        },
        getNameItem(option) {
            this.modelType = option.model
            this.documentData.name = option.id
        },
        setDocDescription(event) {
            if (event) {
                this.documentData.description = this.getDotOptions.filter((option) => option.value === event)[0].text
            }
            else this.documentData.description = ""
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async downloadFile(id) {
            this.setLoader(true)
            const doc = await this.retrieveDocument(id);
            fetch(doc.document)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.blob();
                })
                .then(blob => {
                    const newUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = newUrl;
                    const parts = doc.document.split('/');
                    a.download = parts.pop().split('?')[0];
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(newUrl);
                    a.remove()
                    this.setLoader(false)
                })
                .catch(() => this.setLoader(false));
        },
        resetPopup() {
            this.nameOptions = [],
                this.documentData = {
                    name: "",
                    date: "",
                    expiry_date: "",
                    description: "",
                    driver: false,
                    doc_type: ""
                },
                this.errors = {}
            this.panzoom = null
            this.media = ""
            this.mediaID = ""
            this.nameOptions = []
            this.mediaType = ""
            this.$bvModal.hide('modal-smart-drop-plus-preview')
            this.$emit("close")
        },
        async searchAssets(searchText) {
            if (!searchText) return;

            const allRouteType = this.$route.params.type === 'all'
            const routeType = this.$route.params.type !== 'all' ? this.$route.params.type : null;
            const allowDriverByRoute = !routeType || routeType === 'driver';
            const allowEquipmentByRoute = !routeType || (routeType === 'vehicle' || routeType === 'trailer');

            let options = [];
            let equipmentRecords = [];
            if (
                (allowEquipmentByRoute || allRouteType) &&
                (
                    this.allowCreateDocEquipment ||
                    this.allowCreateOwnerOperatorDocs
                )
            ) {
                equipmentRecords = await this.getFilteredEquipments({ unit_no: searchText });

                equipmentRecords.forEach(item => {
                    options.push({
                        id: `${item.id}`,
                        label: item.unit_no,
                        type: "equipment",
                        model: item.type
                    });
                });
            }
            const shouldSearchDrivers =
                (allowDriverByRoute || allRouteType) &&
                (
                    this.allowCreateDocDrivers
                )

            if (shouldSearchDrivers) {
                const driverRecords = await this.getFilteredDrivers(searchText);

                driverRecords.forEach(item => {
                    options.push({
                        id: `${item.id}`,
                        label: item.name,
                        type: "teammember",
                        model: "Driver"
                    });
                });
            }
            this.nameOptions = [
                ...new Map(options.map(item => [item.id, item])).values()
            ];
        },
        async updateDocument() {
            try {
                const nullKeys = this.checkNullValues({
                    name: this.documentData.name,
                    ...this.company[0].doc_type ? { doc_type: this.documentData.doc_type } : {}
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    delete this.documentData.document;
                    let formData = new FormData();
                    formData.append("object_id", this.documentData.name);
                    formData.append(
                        "date",
                        moment(this.documentData.date).format("YYYY-MM-DD")
                    );
                    formData.append("description", this.documentData.description);
                    formData.append("doc_type", this.documentData.doc_type);
                    formData.append("type", this.documentItem.type);
                    formData.append("expiry_date", this.documentData.expiry_date ? moment(this.documentData.expiry_date).format("YYYY-MM-DD") : '');
                    formData.append("driver", this.documentData.driver);
                    formData.append(
                        "model_type", this.nameOptions.filter(
                            (item) => item.id === this.documentData.name
                        )[0].type
                    )
                    formData.append("company_id", parseInt(localStorage.getItem("userSelectedCompany")));
                    if (this.documentItem.source === 'BOT') formData.append("data_extraction_successful", true);
                    else formData.append("rejected", false)
                    await this.updateTeamMemberDocument({
                        id: this.documentItem.pk,
                        payload: formData,
                    });
                    await this.setNotification({
                        msg: this.$t('smartDropPreview.docUpdated'),
                        type: "success",
                        color: "green",
                    });
                    this.resetPopup()
                    this.setLoader(false)
                    this.$emit('docsUpdated')
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('smartDropPreview.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.errors = error;
                }
            }
        }
    },
}
</script>
<style>
.review-media-section {
    position: absolute;
    top: 0;
    bottom: 0;
    overflow: auto;
    left: 0;
    right: 15px;
    margin-top: 28px;
}

.overflow-preview-auto {
    overflow: auto !important;
    padding-bottom: 1rem !important;
}

.img-section {
    object-fit: contain;
    max-width: -webkit-fill-available;
    max-height: -webkit-fill-available;
    width: auto;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    object-position: top;
}

@media (max-width: 768px) {
    .overflow-preview-auto {
        overflow: auto !important;
    }

    .review-media-section {
        position: relative;
        top: auto;
        bottom: auto;
        overflow: auto;
        left: auto;
        right: auto;
        margin-top: 0px;
        height: 60vh;
        min-height: 300px;
    }
}
</style>
